import { jsx } from "react/jsx-runtime";
const AppImage = ({ src, isRawSrc = false, alt, ...rest }) => {
  return /* @__PURE__ */ jsx("img", { src: isRawSrc ? src : src, alt, ...rest });
};
export {
  AppImage
};
//# sourceMappingURL=index.js.map
